const backups = {
  title: 'Backups',
  menu: 'Backups',
  forbidden: 'You do not have permission to access backups.',
  backupTitle: 'Create backup',
  backupHint:
    'Downloads an encrypted, full-database snapshot. Keep the passphrase safe — the backup cannot be restored without it.',
  passphrase: 'Passphrase',
  passphraseConfirm: 'Confirm passphrase',
  passphraseHint: 'At least %{min} characters.',
  download: 'Download backup',
  backupStarted: 'Backup download started.',
  backupFailed: 'The backup could not be created.',
  restoreTitle: 'Restore backup',
  restoreWarning:
    'Restoring replaces the entire database with the backup content. The application is unavailable while the restore runs. A safety snapshot of the current data is taken first.',
  restore: 'Restore',
  restoreOk: 'Database restored successfully.',
  restoreFailed: 'The backup could not be restored.',
  confirmTitle: 'Restore this backup?',
  confirmBody:
    'This overwrites all current data with the uploaded backup. It cannot be undone from the interface.',
};

export default backups;
